<template>
  <div class="notification">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Dados</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Nome
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="notification.name" class="form-control" />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Email
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="notification.email" class="form-control" />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Tipos de notificação
                      <span class="required-field">*</span>
                    </label>
                    <multiselect
                      v-model="notificationTypes"
                      :multiple="true"
                      :options="createParams.notification_types"
                      selectLabel="Selecione esse item"
                      deselectLabel="Remova esse item"
                      selectedLabel="Selecionado"
                      track-by="id"
                      label="name"
                      placeholder="Selecione as notificacoes"
                    ></multiselect>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button
                    class="btn btn-primary float-right"
                    style="margin-left: 12px"
                    v-on:click="save()"
                  >Salvar</button>
                  <button class="btn btn-secondary float-right" v-if="formType == 'edit'" v-on:click="destroy()">Excluir</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Multiselect from "vue-multiselect";
import validator from "@/imports/validator/validate";
import notification_validate from "@/imports/validator/models/notification";
import helper from "@/imports/Helpers";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "notification",
  components: {
    Multiselect
  },
  props: {
    id: Number
  },
  data() {
    return {
      formType: "create",
      notification: {},
      createParams: {
        notification_types: []
      },
      items: [
        {
          text: "Notificações",
          route: "admin.notifications"
        },
        {
          text: "Nova notificação",
          active: true
        }
      ],
      notificationTypes: []
    };
  },
  mounted() {
    if (this.id) {
      this.formType = "edit";
      this.getDataObject(this.id);
    }
    this.getCreateParams();
  },
  methods: {
    getDataObject: function(id) {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/email_notifications/${id}`)
        .then(response => {
          this.notification = response.data;
          this.notificationTypes = this.notification.notification_types;
          bus.$emit("changeLoading", false);
        });
    },
    getCreateParams: function() {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/email_notifications/create`)
        .then(data => {
          this.createParams = data.data;
          bus.$emit("changeLoading", false);
        });
    },
    save: function() {
      let notification_types_ids = [];
      this.notificationTypes.forEach(el => notification_types_ids.push(el.id));

      this.notification.notificationTypes = notification_types_ids;

      let errors = validator.validate(
        this.notification,
        notification_validate.model
      );

      if (errors.length == 0) {
        bus.$emit("changeLoading", true);

        let promise =
          this.formType == "create"
            ? axios.post(
                `${process.env.VUE_APP_API_HOST}/api/email_notifications`,
                this.notification
              )
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/email_notifications/${this.notification.id}`,
                this.notification
              );

        promise
          .then(response => {
            if (response.data.id) {
              bus.$emit("changeLoading", false);
              Swal.fire({
                title:
                  this.formType == "create"
                    ? "Novo contato cadastrado"
                    : "Contato alterado com sucesso",
                icon: "success",
                onClose: () => {
                  this.$router.push({ name: "admin.notifications" });
                }
              });
            }
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    },
    destroy: function() {
      Swal.fire({
        title: "Você tem certeza que deseja excluir esse item?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.value) {
          let promise = axios.delete(
            `${process.env.VUE_APP_API_HOST}/api/email_notifications/${this.notification.id}`,
            this.notification
          );

          promise.then(response => {
            Swal.fire({
              title: "Item excluído com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.notifications" });
              }
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>